module.exports = __webpack_public_path__ + "media/Art of Promise.34888053.mp3";